import React from "react"
import style from "../UI/style.module.scss"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import config from "../../../config"
import { Tooltip } from "@material-ui/core"
import { Info } from "@material-ui/icons"

export default function LanguageLevelDashboard({ resultData, combine }) {
  const { theme: { bgColors, colors } } = useTheme()
  const { t } = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const languageLevel = resultData.formulaLanguageLevel || -1
  const languageLevelToString = config.languageLevelToString
  const textLanguageLevel = languageLevelToString.find(v => v.threshold < languageLevel)
  return (
    <div className={`${style.RadialBar}`} style={{ backgroundColor: combine ? bgColors.bgMuted : bgColors.bgPrimary0 }}>
      <div style={{ marginBottom: combine ? "0" : "-10%" }}>
        {!combine && <div className={`d-flex justify-content-between pb-2 align-items-center ${style.withBorder}`}>
          <h2 className={`m-0 ${style.withoutBorder} p-0`} style={{ color: colors.colorText }}>{t("dashboard_lang_level")}</h2>
           <Tooltip title={<h6 style={{ fontSize: "15px" }}>{t("dashboard_lang_level_info")}</h6>} className='ml-2 mr-auto'>
                      <Info style={{ fill: colors.colorIcons }} />
                    </Tooltip>
        </div>}
        <div className={`${style.main}`} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: combine ? 'unset' : 'center',
          flexDirection: combine ? 'row' : 'column'
        }}>
          <div className={`${style.chartCont}`} style={{
            height: "200px"
          }}>
            <div className={`${style.chart}`}>
              <div className={style.bars}>
                <h1 style={{ color: isContrast ? colors.colorContrast : textLanguageLevel ? textLanguageLevel.color : colors.colorPrimary500, fontSize: "5rem" }} >
                  {textLanguageLevel ? textLanguageLevel.level : ''}
                </h1>
              </div>
            </div>
          </div>
          <div className={`${style.desc} mt-5`} style={{ marginBottom: "40px", color: colors.colorText, marginLeft: combine ? "75px" : "0" }}>
            { combine ? 
            <>
                    <p>
                        <b style={{ marginRight: "600px" }}>
                          {t(`dashboard_lang_level_desc-${textLanguageLevel.level}`)}
                        </b>
                      <p style={{ marginRight: "-165px", marginTop: "-80px" }}>
                        {<span className={style.sideTextLanguageLevel} style={{ color: isContrast && colors.colorText }}>   Level
                        </span>}
                      </p>
                    </p>
                  </> 
            :
            <p style={{ color: colors.colorText, fontWeight: 'bold' }}>
              {t(`dashboard_lang_level_desc-${textLanguageLevel.level}`)}
            </p>}
          </div>
        </div>
      </div>

    </div>
  )
}
